import axios from 'axios';
import qs from "qs";
import {config} from "libs/constant";

const axiosClient = axios.create({
    baseURL: config.apiUrl,
    headers: {
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        'Content-Type': 'application/json'
    },
    paramsSerializer: params => qs.stringify({...params})
});

axiosClient.interceptors.request.use(async (config) => config);

axiosClient.interceptors.response.use((response) => {
    if (response && response) {
        return response;
    }

    return response;
}, (error) => {
    throw error.response.data;
});

export default axiosClient;
